import axios from "axios";

axios.interceptors.request.use((config) => {
  try {
    const token = localStorage.getItem("xsrfToken");
    if (token) {
      config.headers = config.headers || {};
      const hdrs = config.headers;
      const existingAuth =
        hdrs.Authorization ??
        hdrs.authorization ??
        (typeof hdrs.get === "function" ? hdrs.get("Authorization") : undefined);
      if (!existingAuth) {
        config.headers.Authorization = `Bearer ${token}`;
      }
    }
  } catch {
    // ignore (SSR / tests)
  }
  return config;
});

export default {
  getUserProfile: (payload, resolve, reject) => {
    axios({
      method: "post",
      url: `${process.env.REACT_APP_API_URL}user/info`,
      withCredentials: true,
      data: {},
    })
      .then((res) => resolve(res.data))
      .catch((err) => reject(err));
  },
  getTempWorker: (payload, resolve, reject) => {
    axios({
      method: "post",
      url: `${process.env.REACT_APP_API_URL}tempWorker/info`,
      withCredentials: true,
      data: {},
    })
      .then((res) => resolve(res.data))
      .catch((err) => reject(err));
  },
  getCompanyProfile: (payload, resolve, reject) => {
    axios({
      method: "get",
      url: `${process.env.REACT_APP_API_URL}company/${payload.token}`,
      withCredentials: true,
    })
      .then((res) => resolve(res.data))
      .catch((err) => reject(err));
  },
  postRoleUser: (payload, resolve, reject) => {
    const headers = {};
    if (payload?.token) {
      headers.Authorization = `Bearer ${payload.token}`;
    }
    axios({
      method: "post",
      url: `${process.env.REACT_APP_API_URL}user/role`,
      data: payload?.token ? { token: payload.token } : {},
      headers,
    })
      .then((res) => {
        if (res.data.errors) reject(0, res.data.errors);
        else resolve(res.data);
      })
      .catch((err) => {
        if (reject) reject(1, err);
      });
  },
  postPasswordRefresh: (payload, resolve, reject) => {
    axios({
      method: "put",
      url: `${process.env.REACT_APP_API_URL}user/update/password`,
      withCredentials: true,
      data: {
        oldPwd: payload.password,
        password: payload.newPassword,
        id: payload.id,
      },
    })
      .then((res) => resolve(res.data))
      .catch((err) => reject(err));
  },
  postEmailRefresh: (payload, resolve, reject) => {
    axios({
      method: "put",
      url: `${process.env.REACT_APP_API_URL}user/update/email`,
      withCredentials: true,
      data: {
        email: payload.email,

        tokenMail: payload.tokenMail,
        validation: payload.validation,
      },
    })
      .then((res) => resolve(res.data))
      .catch((err) => reject(err));
  },
  postResendEmailToken: (payload, resolve, reject) => {
    axios({
      method: "post",
      url: `${process.env.REACT_APP_API_URL}resend/tokenMail`,
      data: {
        email: payload.email,
      },
    })
      .then((res) => resolve(res.data))
      .catch((err) => reject(err));
  },
  postCreateTokenMail: (payload, resolve, reject) => {
    axios({
      method: "post",
      url: `${process.env.REACT_APP_API_URL}resend/createToken`,
      data: {
        email: payload.email,

      },
    })
      .then((res) => resolve(res.data))
      .catch((err) => reject(err));
  },

  // Modal
  //******** Language **************
  getListLanguages: (resolve, reject) => {
    axios({
      method: "get",
      url: `${process.env.REACT_APP_API_URL}language`,
    })
      .then((res) => resolve(res.data))
      .catch((err) => reject(err));
  },

  postUserLanguage: (payload, resolve, reject) => {
    axios({
      method: "post",
      url: `${process.env.REACT_APP_API_URL}tempWorker/create/language`,
      withCredentials: true,
      data: {
        language: payload.language,
        isParsing: payload.isParsing,
      },
    })
      .then((res) => {
        if (res.data.errors) reject(0, res.data.errors);
        else resolve(res.data);
      })
      .catch((err) => {
        if (reject) reject(1, err);
      });
  },
  deleteUserLanguage: (payload, resolve, reject) => {
    axios({
      method: "delete",
      url: `${process.env.REACT_APP_API_URL}tempWorker/delete/languages`,
      withCredentials: true,
      data: {

        language: payload.language,
      },
    })
      .then((res) => resolve(res.data))
      .catch((err) => reject(err));
  },
  deleteUserAllLanguages: (payload, resolve, reject) => {
    axios({
      method: "delete",
      url: `${process.env.REACT_APP_API_URL}tempWorker/delete/allLanguages`,
      withCredentials: true,
      data: {},
    })
      .then((res) => resolve(res.data))
      .catch((err) => reject(err));
  },

  //******** Tools **************
  getListTools: (resolve, reject) => {
    axios({
      method: "get",
      url: `${process.env.REACT_APP_API_URL}tools`,
      withCredentials: true,
    })
      .then((res) => resolve(res.data))
      .catch((err) => reject(err));
  },

  postUserTool: (payload, resolve, reject) => {
    axios({
      method: "post",
      url: `${process.env.REACT_APP_API_URL}tempWorker/create/tools`,
      withCredentials: true,
      data: {

        tools: payload.tools,
      },
    })
      .then((res) => resolve(res.data))
      .catch((err) => reject(err));
  },
  postUserToolDelete: (payload, resolve, reject) => {
    axios({
      method: "delete",
      url: `${process.env.REACT_APP_API_URL}tempWorker/delete/tools`,
      withCredentials: true,
      data: {

        tool: payload.tool,
      },
    })
      .then((res) => resolve(res.data))
      .catch((err) => reject(err));
  },
  // Modal
  //******** Language **************
  deleteUserCV: (payload, resolve, reject) => {
    axios({
      method: "delete",
      url: `${process.env.REACT_APP_API_URL}tempWorker/delete/cv`,
      withCredentials: true,
      data: {

        cv: payload.cv,
      },
    })
      .then((res) => resolve(res.data))
      .catch((err) => reject(err));
  },

  // Mission
  //******** GET ALL **************
  getAllMissions: (resolve, reject) => {
    axios({
      method: "get",
      url: `${process.env.REACT_APP_API_URL}mission`,
      withCredentials: true,
    })
      .then((res) => resolve(res.data))
      .catch((err) => reject(err));
  },
  getInfoMission: (payload, resolve, reject) => {
    axios({
      method: "get",
      url: `${process.env.REACT_APP_API_URL}mission/info?id=${payload.id}`,
      withCredentials: true,
    })
      .then((res) => resolve(res.data))
      .catch((err) => reject(err));
  },
  getInfoSearchMission: (payload, resolve, reject) => {
    axios({
      method: "get",
      url: `${process.env.REACT_APP_API_URL}mission/infoSearchMission?idMission=${payload.idMission}`,
      withCredentials: true,
    })
      .then((res) => resolve(res.data))
      .catch((err) => reject(err));
  },
  getInfoMyMission: (payload, resolve, reject) => {
    axios({
      method: "get",
      url: `${process.env.REACT_APP_API_URL}mission/infoMyMission?idMission=${payload.idMission}`,
      withCredentials: true,
    })
      .then((res) => resolve(res.data))
      .catch((err) => reject(err));
  },
  getScheduleByMission: (payload, resolve, reject) => {
    axios({
      method: "get",
      url: `${process.env.REACT_APP_API_URL}schedule/mission/${payload.id}`,
      withCredentials: true,
    })
      .then((res) => resolve(res.data))
      .catch((err) => reject(err));
  },
  postCandidate: (payload, resolve, reject) => {
    axios({
      method: "post",
      url: `${process.env.REACT_APP_API_URL}mission/addUser`,
      withCredentials: true,
      data: {

        mission: payload.mission,
      },
    })
      .then((res) => resolve(res.data))
      .catch((err) => reject(err));
  },
  postVerifyUser: (payload, resolve, reject) => {
    axios({
      method: "post",
      url: `${process.env.REACT_APP_API_URL}mission/verify`,
      withCredentials: true,
      data: {

        missionUser: payload.mission,
      },
    })
      .then((res) => resolve(res.data))
      .catch((err) => reject(err));
  },
  deleteUserMission: (payload, resolve, reject) => {
    axios({
      method: "delete",
      url: `${process.env.REACT_APP_API_URL}mission/deleteUser`,
      withCredentials: true,
      data: {
        mission: payload.mission,
        missionUser: payload.missionUser,
      },
    })
      .then((res) => resolve(res.data))
      .catch((err) => reject(err));
  },
  // FILE
  //******** POST **************
  postFile: (payload, resolve, reject) => {
    const formData = new FormData();
    formData.append("cv", payload.file);
    axios({
      method: "post",
      url: `${process.env.REACT_APP_API_URL}upload/files`,
      withCredentials: true,
      data: formData,
      headers: {
        "content-type": "multipart/form-data",
      },
    })
      .then((res) => resolve(res.data))
      .catch((err) => reject(err));
  },
  //    Modal Experience
  //******** POST **************
  postCreateExp: (payload, resolve, reject) => {
    axios({
      method: "post",
      url: `${process.env.REACT_APP_API_URL}tempWorker/create/experience`,
      withCredentials: true,
      data: {

        experience: payload.experience,
        isParsing: payload.isParsing,
      },
    })
      .then((res) => resolve(res.data))
      .catch((err) => reject(err));
  },
  //******** UPDATE **************
  putUpdateExp: (payload, resolve, reject) => {
    axios({
      method: "put",
      url: `${process.env.REACT_APP_API_URL}tempWorker/update/experience`,
      withCredentials: true,
      data: {

        expID: payload.expID,
        experience: payload.experience,
      },
    })
      .then((res) => resolve(res.data))
      .catch((err) => reject(err));
  },
  //******** DELETE **************
  postDeleteExp: (payload, resolve, reject) => {
    axios({
      method: "delete",
      url: `${process.env.REACT_APP_API_URL}tempWorker/delete/experiences`,
      withCredentials: true,
      data: {

        experienceID: payload.expID,
      },
    })
      .then((res) => resolve(res.data))
      .catch((err) => reject(err));
  },
  deleteUserAllExperiences: (payload, resolve, reject) => {
    axios({
      method: "delete",
      url: `${process.env.REACT_APP_API_URL}tempWorker/delete/allExperiences`,
      withCredentials: true,
      data: {},
    })
      .then((res) => resolve(res.data))
      .catch((err) => reject(err));
  },

  //    Modal Licence
  //******** GET **************
  getLicenceById: (payload, resolve, reject) => {
    axios({
      method: "get",
      url: `${process.env.REACT_APP_API_URL}tempWorker/get/licence?licenceID=${payload.licenceID}`,
      withCredentials: true,
      data: {},
    })
      .then((res) => resolve(res.data))
      .catch((err) => reject(err));
  },
  //******** POST **************
  postUserLicenceWithoutFile: (payload, resolve, reject) => {
    axios({
      method: "post",
      url: `${process.env.REACT_APP_API_URL}tempWorker/create/licences`,
      withCredentials: true,
      data: {

        licence: payload.licence,
        isParsing: payload.isParsing,
      },
    })
      .then((res) => resolve(res.data))
      .catch((err) => reject(err));
  },
  // payload: { file, licence, category, replacedLicenceId }. category only for a catalogue entry
  // that has some (CACES); replacedLicenceId only to replace a refused entry, the api ignores it
  // for an accepted one.
  uploadLicenceFile: (payload, resolve, reject) => {
    const formData = new FormData();
    formData.append("licence", payload.file);
    formData.append("licenceName", payload.licence);
    if (payload.category) formData.append("licenceCategory", payload.category);
    if (payload.replacedLicenceId) formData.append("licenceID", payload.replacedLicenceId);
    axios({
      method: "post",
      url: `${process.env.REACT_APP_API_URL}upload/files`,
      withCredentials: true,
      data: formData,
    })
      .then((res) => resolve(res.data))
      .catch((err) => reject(err));
  },
  //******** GET **************
  getAllLicence: (resolve, reject) => {
    axios({
      method: "get",
      url: `${process.env.REACT_APP_API_URL}licence`,
    })
      .then((res) => resolve(res.data))
      .catch((err) => reject(err));
  },
  getAllOtherDocumentTypes: (resolve, reject) => {
    axios({
      method: "get",
      url: `${process.env.REACT_APP_API_URL}otherDocumentType`,
    })
      .then((res) => resolve(res.data))
      .catch((err) => reject(err));
  },
  //******** UPDATE **************
  //******** DELETE **************
  postDeleteOtherDocument: (payload, resolve, reject) => {
    axios({
      method: "delete",
      url: `${process.env.REACT_APP_API_URL}tempWorker/delete/otherDocument`,
      withCredentials: true,
      data: {

        documentId: payload.documentId,
      },
    })
      .then((res) => resolve(res.data))
      .catch((err) => reject(err));
  },
  postDeleteLicence: (payload, resolve, reject) => {
    axios({
      method: "delete",
      url: `${process.env.REACT_APP_API_URL}tempWorker/delete/licence`,
      withCredentials: true,
      data: {

        licence: payload.objID,
      },
    })
      .then((res) => resolve(res.data))
      .catch((err) => reject(err));
  },

  deleteUserAllLicences: (payload, resolve, reject) => {
    axios({
      method: "delete",
      url: `${process.env.REACT_APP_API_URL}tempWorker/delete/allLicences`,
      withCredentials: true,
      data: {},
    })
      .then((res) => resolve(res.data))
      .catch((err) => reject(err));
  },
  //    Modal Formation
  //******** GET **************
  getFormationById: (payload, resolve, reject) => {
    axios({
      method: "get",
      url: `${process.env.REACT_APP_API_URL}tempWorker/get/formation?formationID=${payload.formationID}`,
    })
      .then((res) => resolve(res.data))
      .catch((err) => reject(err));
  },
  //******** POST **************
  postUserFormationWithoutFile: (payload, resolve, reject) => {
    axios({
      method: "post",
      url: `${process.env.REACT_APP_API_URL}tempWorker/create/formations`,
      withCredentials: true,
      data: {

        formation: payload.formation,
        description: payload.description,
        isParsing: payload.isParsing,
      },
    })
      .then((res) => resolve(res.data))
      .catch((err) => reject(err));
  },
  //******** UPDATE **************
  putUpdateFormation: (payload, resolve, reject) => {
    axios({
      method: "put",
      url: `${process.env.REACT_APP_API_URL}tempWorker/update/formation`,
      withCredentials: true,
      data: {

        formationID: payload.formationID,
        formation: payload.formation,
        description: payload.description,
      },
    })
      .then((res) => resolve(res.data))
      .catch((err) => reject(err));
  },
  //******** DELETE **************
  postDeleteFormation: (payload, resolve, reject) => {
    axios({
      method: "delete",
      url: `${process.env.REACT_APP_API_URL}tempWorker/delete/training`,
      withCredentials: true,
      data: {

        formation: payload.objID,
      },
    })
      .then((res) => resolve(res.data))
      .catch((err) => reject(err));
  },
  deleteUserAllFormations: (payload, resolve, reject) => {
    axios({
      method: "delete",
      url: `${process.env.REACT_APP_API_URL}tempWorker/delete/allFormations`,
      withCredentials: true,
      data: {},
    })
      .then((res) => resolve(res.data))
      .catch((err) => reject(err));
  },
  //     JUSTIFICATIFS
  //    IBAN
  //******** POST **************
  postUpdateIban: (payload, resolve, reject) => {
    axios({
      method: "put",
      url: `${process.env.REACT_APP_API_URL}tempWorker/update/bank`,
      withCredentials: true,
      data: {

        bank: payload.iban,
      },
    })
      .then((res) => resolve(res.data))
      .catch((err) => reject(err));
  },

  //    ACCOUNT
  //******** POST **************
  postUpdateCivility: (payload, resolve, reject) => {
    axios({
      method: "put",
      url: `${process.env.REACT_APP_API_URL}user/update/civility`,
      withCredentials: true,
      data: {

        civility: payload.civility,
      },
    })
      .then((res) => resolve(res.data))
      .catch((err) => reject(err));
  },

  postUpdatePhone: (payload, resolve, reject) => {
    axios({
      method: "put",
      url: `${process.env.REACT_APP_API_URL}user/update/phone`,
      withCredentials: true,
      data: {

        phone: payload.phone,
      },
    })
      .then((res) => resolve(res.data))
      .catch((err) => reject(err));
  },

  postUpdateAddress: (payload, resolve, reject) => {
    axios({
      method: "post",
      url: `${process.env.REACT_APP_API_URL}address/add`,
      withCredentials: true,
      data: {

        address: payload.address,
      },
    })
      .then((res) => resolve(res.data))
      .catch((err) => reject(err));
  },
  getAddress: (payload, resolve, reject) => {
    axios({
      method: "get",
      url: `${process.env.REACT_APP_API_URL}address/${payload.address}`,
      withCredentials: true,
    })
      .then((res) => resolve(res.data))
      .catch((err) => reject(err));
  },
  //    Time Sheets
  getTimeSheets: (payload, resolve, reject) => {
    axios({
      method: "post",
      url: `${process.env.REACT_APP_API_URL}timeSheets/allInfo`,
      withCredentials: true,
      data: payload && typeof payload === "object" ? payload : {},
    })
      .then((res) => resolve(res.data))
      .catch((err) => reject(err));
  },
  getTimeSheetInfo: (payload, resolve, reject) => {
    axios({
      method: "get",
      url: `${process.env.REACT_APP_API_URL}timeSheets/${payload.id}`,
      withCredentials: true,
    })
      .then((res) => resolve(res.data))
      .catch((err) => reject(err));
  },
  //******** POST **************
  postUpdateDay: (payload, resolve, reject) => {
    axios({
      method: "put",
      url: `${process.env.REACT_APP_API_URL}timeSheets/updateDay`,
      withCredentials: true,
      data: {
        timeDay: payload.timeData,

      },
    })
      .then((res) => resolve(res.data))
      .catch((err) => reject(err));
  },
  postUpdateWeek: (payload, resolve, reject) => {
    axios({
      method: "put",
      url: `${process.env.REACT_APP_API_URL}timeSheets/updateWeek`,
      withCredentials: true,
      data: {
        id: payload.id,
        tHours: payload.totalH,

      },
    })
      .then((res) => resolve(res.data))
      .catch((err) => reject(err));
  },
  //    CONTRACT
  //******** GET **************
  getContracts: (payload, resolve, reject) => {
    axios({
      method: "get",
      url: `${process.env.REACT_APP_API_URL}mission/contract/tempworker?status=${payload.pStatus}${
        payload.includePending ? "&includePending=true" : ""
      }`,
      withCredentials: true,
    })
      .then((res) => resolve(res.data))
      .catch((err) => reject(err));
  },
  //******** PUT **************
  putStatusContract: (payload, resolve, reject) => {
    axios({
      method: "post",
      url: `${process.env.REACT_APP_API_URL}mission/updateContractTempworker`,
      withCredentials: true,
      data: {
        contract: payload.contract,
      },
    })
      .then((res) => resolve(res.data))
      .catch((err) => reject(err));
  },
  getSignatureLink: (payload, resolve, reject) => {
    axios({
      method: "get",
      url: `${process.env.REACT_APP_API_URL}mission/contract/signatureLink`,
      withCredentials: true,
      params: {
        idMission: payload.idMission,
        contractId: payload.contractId,
      },
    })
      .then((res) => resolve(res.data))
      .catch((err) => reject(err));
  },
  getMissions: (payload, resolve, reject) => {
    axios({
      method: "get",
      url: `${process.env.REACT_APP_API_URL}mission/tempWorker`,
      withCredentials: true,
    })
      .then((res) => resolve(res.data))
      .catch((err) => reject(err));
  },
  /*********SUPPORT*********/
  postSupportMessaging: (payload, resolve, reject) => {
    axios({
      method: "post",
      url: `${process.env.REACT_APP_API_URL}support/messaging`,
      withCredentials: true,
      data: {
        user_sender: payload.user_sender,
        mail_messaging: payload.mail_messaging,
        type_message: payload.type_message,
      },
    })
      .then((res) => resolve(res.data))
      .catch((err) => reject(err));
  },
  putHideProfileCompletion: (payload, resolve, reject) => {
    axios({
      method: "put",
      url: `${process.env.REACT_APP_API_URL}tempWorker/update/hideProfileCompletion`,
      withCredentials: true,
      data: {},
    })
      .then((res) => resolve(res.data))
      .catch((err) => reject(err));
  },
  putUpdateHrflowCandidate: (payload, resolve, reject) => {
    axios({
      method: "put",
      url: `${process.env.REACT_APP_API_URL}tempWorker/update/hrflowCandidate`,
      withCredentials: true,
      data: {

        data: payload.data,
      },
    })
      .then((res) => resolve(res.data))
      .catch((err) => reject(err));
  },
  putCheckTutoBreaks: (payload, resolve, reject) => {
    axios({
      method: "put",
      url: `${process.env.REACT_APP_API_URL}tempWorker/checkTutoBreaks`,
      withCredentials: true,
      data: {},
    })
      .then((res) => resolve(res.data))
      .catch((err) => reject(err));
  },
  postUpdateSocialSecurity: (payload, resolve, reject) => {
    axios({
      method: "post",
      url: `${process.env.REACT_APP_API_URL}tempWorker/update/social_security`,
      withCredentials: true,
      data: {

        socialSecurity: payload.socialSecurity,
      },
    })
      .then((res) => resolve(res.data))
      .catch((err) => reject(err));
  },
  putUnavailableDay: (payload, resolve, reject) => {
    axios({
      method: "put",
      url: `${process.env.REACT_APP_API_URL}tempWorker/update/unavailableDay`,
      withCredentials: true,
      data: {

        day: payload.day,
        isUnavailable: payload.isUnavailable,
      },
    })
      .then((res) => resolve(res.data))
      .catch((err) => reject(err));
  },
  putAvailability: (payload, resolve, reject) => {
    axios({
      method: "put",
      url: `${process.env.REACT_APP_API_URL}tempWorker/update/availability`,
      withCredentials: true,
      data: {

        dateStart: payload.dateStart,
        dateEnd: payload.dateEnd,
        is_available: payload.is_available,
      },
    })
      .then((res) => resolve(res.data))
      .catch((err) => reject(err));
  },
  putWelcomeGuide: (payload, resolve, reject) => {
    axios({
      method: "put",
      url: `${process.env.REACT_APP_API_URL}tempWorker/update/putWelcomeGuide`,
      withCredentials: true,
      data: {},
    })
      .then((res) => resolve(res.data))
      .catch((err) => reject(err));
  },
  putSafetyBooklet: (payload, resolve, reject) => {
    axios({
      method: "put",
      url: `${process.env.REACT_APP_API_URL}tempWorker/update/putSafetyBooklet`,
      withCredentials: true,
      data: {},
    })
      .then((res) => resolve(res.data))
      .catch((err) => reject(err));
  },
  putHealthGuide: (payload, resolve, reject) => {
    axios({
      method: "put",
      url: `${process.env.REACT_APP_API_URL}tempWorker/update/putHealthGuide`,
      withCredentials: true,
      data: {},
    })
      .then((res) => resolve(res.data))
      .catch((err) => reject(err));
  },
  getUserPayslips: (payload, resolve, reject) => {
    axios({
      method: "get",
      url: `${process.env.REACT_APP_API_URL}tempWorker/userPaysSlips`,
      withCredentials: true,
    })
      .then((res) => resolve(res.data))
      .catch((err) => reject(err));
  },
  putReadPayslip: (payload, resolve, reject) => {
    axios({
      method: "put",
      url: `${process.env.REACT_APP_API_URL}tempWorker/update/putReadPayslip`,
      withCredentials: true,
      data: {

        idPayslip: payload.idPayslip,
      },
    })
      .then((res) => resolve(res.data))
      .catch((err) => reject(err));
  },
  getEndOfMissionDocuments: (payload, resolve, reject) => {
    axios({
      method: "get",
      url: `${process.env.REACT_APP_API_URL}tempWorker/endOfMissionDocuments`,
      withCredentials: true,
    })
      .then((res) => resolve(res.data))
      .catch((err) => reject(err));
  },
  openEndOfMissionDocument: (payload, resolve, reject) => {
    const headers = {};
    let url = `${process.env.REACT_APP_API_URL}tempWorker/endOfMissionDocuments/${encodeURIComponent(payload.id)}/open`;
    // Same query-token fallback as postPresignFiles: a mobile WebView opening
    // /pdfView?token= may omit the Authorization header on XHR.
    if (payload?.token) {
      headers.Authorization = `Bearer ${payload.token}`;
      url += `?${new URLSearchParams({ token: payload.token }).toString()}`;
    }
    axios({
      method: "post",
      url,
      withCredentials: payload?.token ? false : true,
      headers,
    })
      .then((res) => resolve(res.data))
      .catch((err) => reject(err));
  },
  postUserInviteMissionAccept: (payload, resolve, reject) => {
    axios({
      method: "post",
      url: `${process.env.REACT_APP_API_URL}mission/inviteAccept`,
      withCredentials: true,
      data: {

        idMission: payload.idMission,
      },
    })
      .then((res) => resolve(res.data))
      .catch((err) => reject(err));
  },
  postUserInviteMissionRefuse: (payload, resolve, reject) => {
    axios({
      method: "post",
      url: `${process.env.REACT_APP_API_URL}mission/inviteRefuse`,
      withCredentials: true,
      data: {

        idMission: payload.idMission,
      },
    })
      .then((res) => resolve(res.data))
      .catch((err) => reject(err));
  },
  getCities: (payload, resolve, reject) => {
    axios({
      method: "get",
      url: `${process.env.REACT_APP_API_URL}city`,
      withCredentials: true,
    })
      .then((res) => resolve(res.data))
      .catch((err) => reject(err));
  },
  updPreferenceDepartment: (payload, resolve, reject) => {
    axios({
      method: "put",
      url: `${process.env.REACT_APP_API_URL}tempWorker/update/preferenceDepartment`,
      withCredentials: true,
      data: {

        preferences_department: payload.preferences_department,
      },
    })
      .then((res) => resolve(res.data))
      .catch((err) => reject(err));
  },
  searchMission: (payload, resolve, reject) => {
    axios({
      method: "get",
      url: `${process.env.REACT_APP_API_URL}mission/searchMission?search=${payload.search}&department=${payload.department}&postule=${payload.postule}&typesQualifications=${payload.typesQualifications}`,
      withCredentials: true,
    })
      .then((res) => resolve(res.data))
      .catch((err) => reject(err));
  },
  getTypesQualifications: (payload, resolve, reject) => {
    axios({
      method: "get",
      url: `${process.env.REACT_APP_API_URL}qualification/getTypesQualifications`,
      withCredentials: true,
    })
      .then((res) => resolve(res.data))
      .catch((err) => reject(err));
  },
  deleteAccount: (payload, resolve, reject) => {
    axios({
      method: "post",
      url: `${process.env.REACT_APP_API_URL}user/userAccountDeletion`,
      withCredentials: true,
      data: {

        reason: payload.reason,
      },
    })
      .then((res) => resolve(res.data))
      .catch((err) => reject(err));
  },
  isDeleteAccount: (payload, resolve, reject) => {
    axios({
      method: "post",
      url: `${process.env.REACT_APP_API_URL}user/checkUserAccountDeletion`,
      withCredentials: true,
      data: {},
    })
      .then((res) => resolve(res.data))
      .catch((err) => reject(err));
  },
  postPresignFiles: (payload, resolve, reject) => {
    const headers = {};
    const usesQueryBearer = Boolean(payload?.token);
    if (payload?.token) {
      headers.Authorization = `Bearer ${payload.token}`;
    }
    // Query token: extractRefreshToken runs before express.json(); iOS WebView can omit
    // Authorization on XHR while still attaching ?token= (see api/middleware/extractRefreshToken.js).
    let url = `${process.env.REACT_APP_API_URL}user/presignFiles`;
    if (payload?.token) {
      url += `?${new URLSearchParams({ token: payload.token }).toString()}`;
    }
    axios({
      method: "post",
      url,
      // Mobile pdfView: avoid sending legacy site cookies (private tab works; WebView may not).
      withCredentials: payload?.token ? false : true,
      headers,
      data: {

        type: payload.type,
        fileName: payload.fileName,
        // A licence document is signed by its entry id ({ type: 'licence', licenceId }).
        ...(payload?.licenceId ? { licenceId: payload.licenceId } : {}),
      },
    })
      .then((res) => {
        const body = res.data;
        console.log("[postPresignFiles] http ok", {
          httpStatus: res.status,
          bodyType: typeof body,
          urlsLength: Array.isArray(body?.urls) ? body.urls.length : "(not array)",
          bodyKeys:
            body && typeof body === "object" ? Object.keys(body) : [],
        });
        resolve(body);
      })
      .catch((err) => {
        console.error("[postPresignFiles] http error", {
          message: err?.message,
          code: err?.code,
          status: err?.response?.status,
          statusText: err?.response?.statusText,
          responseData: err?.response?.data,
        });
        reject(err);
      });
  },
  postPresignPublicFiles: (payload, resolve, reject) => {
    axios({
      method: "post",
      url: `${process.env.REACT_APP_API_URL}user/presignPublicFiles`,
      withCredentials: true,
      data: {

        type: payload.type,
        fileName: payload.fileName,
      },
    })
      .then((res) => resolve(res.data))
      .catch((err) => reject(err));
  },
  getCityDepartments: (payload, resolve, reject) => {
    axios({
      method: "get",
      url: `${process.env.REACT_APP_API_URL}city/departments`,
      withCredentials: true,
      params: {

      },
    })
      .then((res) => resolve(res.data))
      .catch((err) => reject(err));
  },
  getTempWorkerMissionStatusInfo: (payload, resolve, reject) => {
    axios({
      method: "get",
      url: `${process.env.REACT_APP_API_URL}mission/tempWorkerMissionStatusInfo?idMission=${payload.idMission}`,
      withCredentials: true,
    })
      .then((res) => resolve(res.data))
      .catch((err) => reject(err));
  },
  postTempWorkerMissionStatusChange: (payload, resolve, reject) => {
    axios({
      method: "post",
      url: `${process.env.REACT_APP_API_URL}mission/tempWorkerMissionStatusChange`,
      withCredentials: true,
      data: {

        idMission: payload.idMission,
        newStatus: payload.newStatus,
        reason: payload.reason,
        description: payload.description,
        endDate: payload.endDate,
        filePath: payload.filePath,
        fileName: payload.fileName,
      },
    })
      .then((res) => resolve(res.data))
      .catch((err) => reject(err));
  },
  getContractsAndAmendments: (payload, resolve, reject) => {
    axios({
      method: "get",
      url: `${process.env.REACT_APP_API_URL}mission/contractsAndAmendments?idMission=${payload.idMission}`,
      withCredentials: true,
    })
      .then((res) => resolve(res.data))
      .catch((err) => reject(err));
  },
  getAmendmentRequests: (payload, resolve, reject) => {
    axios({
      method: "get",
      url: `${process.env.REACT_APP_API_URL}mission/amendmentRequests${payload.idMission ? `?idMission=${payload.idMission}` : ""}`,
      withCredentials: true,
    })
      .then((res) => resolve(res.data))
      .catch((err) => reject(err));
  },
  respondAmendment: (payload, resolve, reject) => {
    axios({
      method: "post",
      url: `${process.env.REACT_APP_API_URL}mission/respondAmendment`,
      withCredentials: true,
      data: {

        idRequest: payload.idRequest,
        response: payload.response,
      },
    })
      .then((res) => resolve(res.data))
      .catch((err) => reject(err));
  },
  // Residence permit extension proof
  // payload = FormData { type, fileR, fileV (new_permit only) }
  uploadVisaComplementaryDocument: (payload, resolve, reject) => {
    axios({
      method: "post",
      url: `${process.env.REACT_APP_API_URL}tempWorker/visa/complementaryDocuments`,
      withCredentials: true,
      data: payload,
      headers: {
        "content-type": "multipart/form-data",
      },
    })
      .then((res) => resolve(res.data))
      .catch((err) => reject(err));
  },
};